// src/pages/public/Enterprises.jsx
import React, { useState, useMemo, forwardRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  Building, Phone, Mail, Globe, PiggyBank, Fish, HeartHandshake, 
  Sprout, Building2, Briefcase, Layers, Sparkles, Monitor, 
  TrendingUp, Users, Award, Factory, Leaf, TreePine, Truck, 
  Rocket, GraduationCap, Database, BarChart3, Search, Filter, 
  ExternalLink, ChevronRight, MapPin, Calendar, DollarSign
} from 'lucide-react';

const enterprisesData = [
  {
    id: 1,
    name: 'AfricaNut Industry',
    logo: 'https://res.cloudinary.com/djhyztec8/image/fetch/v1754811262/https://harmonious-boba-e7278d.netlify.app/cld-assets/images/partners/AFRICANUT_FISH_MARKET.png',
    image: 'https://res.cloudinary.com/djhyztec8/image/upload/v1754812663/WhatsApp_Image_2024-10-08_%C3%A0_11.42.46_edf79ff4_cmppa6.jpg',
    activity: 'Production et commercialisation de poisson, alimentation animale. Conception d\'outils numériques et développement culturel.',
    products: 'Poissons (silure, tilapia), aliments pour poissons, équipements aquacoles, solutions digitales.',
    production: 'Production annuelle de 7 tonnes de poisson. Plateformes numériques en développement.',
    founder: 'ESSOLA ONJA\'A FELIX MAGLOIRE',
    contact: {
      phone: '+237 6 20 37 02 86 / +237 656 816 240',
      email: 'africanutindustry@outlook.com',
      website: 'https://www.africanutgroup.com'
    },
    stats: { employees: '6', years: '5', clients: '250+' },
    tags: ['Aquaculture', 'Agro-industrie', 'Innovation'],
    iconBg: 'bg-blue-50 text-blue-600 border-blue-100'
  },
  {
    id: 2,
    name: 'Nouvelle Académie Numérique Africaine (NA²)',
    logo: 'https://res.cloudinary.com/djhyztec8/image/upload/v1755204980/logo_t9bd7r.png',
    image: 'https://res.cloudinary.com/djhyztec8/image/upload/v1783107282/kling_20260417_IMAGE_PlanDur_eV_3707_0_uefukz.png',
    activity: 'Plateforme numérique éducative et de gestion des productions agricoles et agro-industrielles. Conception d\'outils digitaux.',
    products: 'NA² Quiz Training, Pisciculture Pro, Assoc Planner, outils de gestion agricole.',
    production: '5+ applications déployées, 200+ utilisateurs actifs.',
    founder: 'ESSOLA ONJA\'A FELIX MAGLOIRE',
    contact: {
      phone: '+237 6 20 37 02 86',
      email: 'contact@na2africa.com',
      website: 'https://www.na2africa.com'
    },
    stats: { employees: '3', years: '4', clients: '100+' },
    tags: ['EdTech', 'AgriTech', 'Innovation Numérique'],
    iconBg: 'bg-purple-50 text-purple-600 border-purple-100'
  },
  {
    id: 4,
    name: 'Association des Experts pour le Développement Durable (ASEDD)',
    logo: '',
    image: 'https://res.cloudinary.com/djhyztec8/image/upload/v1782133330/WhatsApp_Image_2026-06-22_at_06.45.41_1_ydjnjn.jpg',
    activity: 'Production de semences forestiers et agricoles, prestataires de services, plateforme de vente de semences.',
    products: 'Semences forestières, semences agricoles, services de conseil, prestations techniques.',
    production: 'Production de 1000+ plants par an. Plateforme de vente en ligne.',
    founder: 'MOUYAKAN A MOUMBOCK Elvis',
    contact: {
      phone: '+237 679 761 484',
      email: 'mouyakanelvis@gmail.com',
      website: ''
    },
    stats: { employees: '5', years: '7', clients: '80+' },
    tags: ['Semences', 'Agroforesterie', 'Développement Durable'],
    iconBg: 'bg-emerald-50 text-emerald-600 border-emerald-100'
  },
  {
    id: 5,
    name: 'SCOOPS I-AGRI',
    logo: '',
    image: 'https://res.cloudinary.com/djhyztec8/image/upload/v1754813075/vue-pres-du-mais-encore-dans-sa-coquille_r3r22n.jpg',
    activity: 'Pépinière - Production de plants performants de toutes espèces. Réhabilitation de vergers cacaoyers.',
    products: 'Plants de cacao, plants fruitiers, plants forestiers, services de pépinière.',
    production: '50 000 plants produits par an.',
    founder: 'EDONGO ABEGA DAVY FABRICE',
    contact: {
      phone: '+237 696 322 069',
      email: 'davy_e@yahoo.fr',
      website: ''
    },
    stats: { employees: '4', years: '6', clients: '60+' },
    tags: ['Pépinière', 'Cacao', 'Agroforesterie'],
    iconBg: 'bg-amber-50 text-amber-600 border-amber-100'
  },
  {
    id: 6,
    name: 'Velia Sarl',
    logo: '',
    image: 'https://res.cloudinary.com/djhyztec8/image/upload/v1782069583/IMG_2820_fy1wdj.jpg',
    activity: 'Services conseil agricole, développement d\'entreprises agroalimentaires, vente d\'engrais et produits phytosanitaires.',
    products: 'Conseil agricole, engrais, produits phytosanitaires, formations.',
    production: 'Accompagnement de 200+ agriculteurs par an.',
    founder: 'KENGNI Thibault',
    contact: {
      phone: '+237 676 10 38 27 / +237 656 79 83 26',
      email: 'Kengnithibault@yahoo.com',
      website: ''
    },
    stats: { employees: '3', years: '5', clients: '200+' },
    tags: ['Conseil Agricole', 'Agroalimentaire'],
    iconBg: 'bg-indigo-50 text-indigo-600 border-indigo-100'
  },
  {
    id: 8,
    name: 'Ets MDM',
    logo: '',
    image: 'https://res.cloudinary.com/djhyztec8/image/upload/v1754815391/front-view-plants-with-coins-stacked-dirt_erjelb.jpg',
    activity: 'Agriculture services - Importation et exportation de produits agricoles.',
    products: 'Produits agricoles, services d\'import/export, inspections phytosanitaires.',
    production: 'Volumes d\'exportation en croissance.',
    founder: 'MEYIFY DEBILOGO MARTEL',
    contact: {
      phone: '+237 697 780 003',
      email: 'fymartel@gmail.com',
      website: ''
    },
    stats: { employees: '4', years: '8', clients: '30+' },
    tags: ['Import/Export', 'Agriculture'],
    iconBg: 'bg-rose-50 text-rose-600 border-rose-100'
  }
];

const comingSoonData = [
  { 
    name: 'Hub Numérique d\'Expertise AIFASA 17', 
    activity: 'Plateforme intelligente de valorisation des compétences, marketplace de services et outils de mesure de performance.',
    icon: Rocket,
    bgColor: 'from-blue-50/60 to-indigo-50/60',
    iconColor: 'text-blue-600',
    borderColor: 'border-blue-100',
    axe: 'Axe Digital', budget: 'Stratégique', deadline: 'T3 2026'
  },
  { 
    name: 'NA² Quiz Training', 
    activity: 'Plateforme éducative pour répétitions et évaluations. Référentiel complet du système éducatif camerounais.',
    icon: GraduationCap,
    bgColor: 'from-purple-50/60 to-pink-50/60',
    iconColor: 'text-purple-600',
    borderColor: 'border-purple-100',
    axe: 'EdTech', budget: 'Pilote', deadline: 'T4 2026'
  },
  { 
    name: 'Pisciculture Pro Management', 
    activity: 'Gestion aquacole complète : lots, suivi d\'élevage, paramètres physico-chimiques, stocks, ventes et analyses.',
    icon: Fish,
    bgColor: 'from-cyan-50/60 to-blue-50/60',
    iconColor: 'text-cyan-600',
    borderColor: 'border-cyan-100',
    axe: 'AgriTech', budget: 'Déploiement', deadline: 'T1 2027'
  },
  { 
    name: 'Plateforme Élevages Diversifiés', 
    activity: 'Extension aux filières avicole et porcine : suivi des élevages, santé animale, production, gestion des stocks et ventes.',
    icon: PiggyBank,
    bgColor: 'from-amber-50/60 to-orange-50/60',
    iconColor: 'text-amber-600',
    borderColor: 'border-amber-100',
    axe: 'Élevage', budget: 'R&D', deadline: 'T2 2027'
  },
  { 
    name: 'Base de Données Agro-Pastorales', 
    activity: 'Centre de ressources statistiques pour l\'évaluation du développement rural - référence nationale et sous-régionale.',
    icon: Database,
    bgColor: 'from-emerald-50/60 to-green-50/60',
    iconColor: 'text-emerald-600',
    borderColor: 'border-emerald-100',
    axe: 'Big Data', budget: 'Mutualisé', deadline: 'T3 2027'
  },
  { 
    name: 'Dashboard KPI & Performance', 
    activity: 'Tableau de bord analytique intégré : suivi des indicateurs clés de performance et rapports automatiques.',
    icon: BarChart3,
    bgColor: 'from-slate-50/60 to-gray-50/60',
    iconColor: 'text-slate-600',
    borderColor: 'border-slate-100',
    axe: 'Gouvernance', budget: 'Interne', deadline: 'En continu'
  },
];

const getIconForActivity = (activity) => {
  const act = activity.toLowerCase();
  if (act.includes('piscicole') || act.includes('poissons') || act.includes('halieutique') || act.includes('aquacole') || act.includes('poisson')) 
    return <Fish className="w-4 h-4" />;
  if (act.includes('numérique') || act.includes('plateforme') || act.includes('digital') || act.includes('edtech')) 
    return <Monitor className="w-4 h-4" />;
  if (act.includes('semence') || act.includes('pépinière') || act.includes('plants')) 
    return <Leaf className="w-4 h-4" />;
  if (act.includes('conseil') || act.includes('études') || act.includes('expert')) 
    return <Building2 className="w-4 h-4" />;
  if (act.includes('coopérative') || act.includes('mutualisation')) 
    return <HeartHandshake className="w-4 h-4" />;
  if (act.includes('forêt') || act.includes('agroforesterie')) 
    return <TreePine className="w-4 h-4" />;
  return <Building className="w-4 h-4" />;
};

// ✅ COMPOSANT CORRIGÉ AVEC forwardRef
const EnterpriseCard = forwardRef(({ enterprise, index }, ref) => {
  return (
    <motion.div
      ref={ref}
      layout
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.3, delay: index * 0.05 }}
      className="bg-white rounded-2xl border border-gray-100 overflow-hidden flex flex-col h-full hover:shadow-xl hover:border-gray-200/80 transition-all duration-300 group"
    >
      {/* Cover Image Container */}
      <div className="h-48 w-full overflow-hidden relative bg-gray-100">
        <img
          src={enterprise.image}
          alt={enterprise.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
          onError={(e) => {
            e.target.src = `https://images.unsplash.com/photo-1530595467537-0b5996c41f2d?q=80&w=600&auto=format&fit=crop`;
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-950/40 via-transparent to-transparent" />
        
        <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-md p-2 rounded-xl shadow-sm border border-white/20 text-gray-700">
          {getIconForActivity(enterprise.activity)}
        </div>
        
        <div className="absolute bottom-3 left-3 bg-white/90 backdrop-blur-md text-gray-800 text-[11px] font-semibold px-3 py-1.5 rounded-xl flex items-center gap-1.5 shadow-sm border border-white/40">
          <Users className="w-3.5 h-3.5 text-emerald-600" />
          <span className="truncate max-w-[180px]">{enterprise.founder}</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="p-6 flex-1 flex flex-col">
        <div className="flex items-center mb-5 pb-4 border-b border-gray-100">
          {enterprise.logo ? (
            <img
              src={enterprise.logo}
              alt={`${enterprise.name} logo`}
              className="w-12 h-12 rounded-xl mr-3.5 object-contain bg-gray-50 border border-gray-100 p-1.5 flex-shrink-0"
            />
          ) : (
            <div className={`w-12 h-12 rounded-xl mr-3.5 ${enterprise.iconBg || 'bg-emerald-600 text-white'} font-bold flex items-center justify-center text-base shadow-inner flex-shrink-0 border`}>
              {enterprise.name.charAt(0)}
            </div>
          )}
          <h3 className="text-base font-bold text-gray-900 leading-snug group-hover:text-emerald-700 transition-colors line-clamp-2">
            {enterprise.name}
          </h3>
        </div>

        <div className="space-y-4 text-xs md:text-sm text-gray-600 flex-1">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5 text-gray-400">
              <Building className="w-4 h-4" />
            </div>
            <div>
              <span className="text-[10px] uppercase font-bold tracking-wider text-gray-400 block">Activités</span>
              <p className="text-gray-700 mt-0.5 leading-relaxed line-clamp-3">{enterprise.activity}</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5 text-emerald-600">
              <Briefcase className="w-4 h-4" />
            </div>
            <div>
              <span className="text-[10px] uppercase font-bold tracking-wider text-gray-400 block">Offre & Produits</span>
              <p className="text-gray-700 mt-0.5 leading-relaxed">{enterprise.products}</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5 text-blue-600">
              <Layers className="w-4 h-4" />
            </div>
            <div>
              <span className="text-[10px] uppercase font-bold tracking-wider text-gray-400 block">Capacité opérationnelle</span>
              <p className="text-gray-700 mt-0.5 leading-relaxed text-xs bg-gray-50 px-2.5 py-1.5 rounded-lg border border-gray-100/60 mt-1">{enterprise.production}</p>
            </div>
          </div>

          {/* Key Metrics */}
          {enterprise.stats && (
            <div className="grid grid-cols-3 gap-2 pt-2 border-t border-gray-50">
              <div className="text-center bg-gray-50/50 rounded-xl p-2 border border-gray-100">
                <p className="text-[9px] font-medium text-gray-400 uppercase tracking-tight">Équipe</p>
                <p className="text-xs font-bold text-gray-800 mt-0.5">{enterprise.stats.employees} p.</p>
              </div>
              <div className="text-center bg-gray-50/50 rounded-xl p-2 border border-gray-100">
                <p className="text-[9px] font-medium text-gray-400 uppercase tracking-tight">Ancienneté</p>
                <p className="text-xs font-bold text-gray-800 mt-0.5">{enterprise.stats.years} ans</p>
              </div>
              <div className="text-center bg-gray-50/50 rounded-xl p-2 border border-gray-100">
                <p className="text-[9px] font-medium text-gray-400 uppercase tracking-tight">Clients</p>
                <p className="text-xs font-bold text-gray-800 mt-0.5">{enterprise.stats.clients}</p>
              </div>
            </div>
          )}

          {/* Tags */}
          {enterprise.tags && (
            <div className="flex flex-wrap gap-1.5 pt-2">
              {enterprise.tags.map((tag, i) => (
                <span key={i} className="text-[10px] bg-gray-100 text-gray-700 px-2.5 py-0.5 rounded-md font-medium border border-gray-200/40">
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Footer / Contact Details */}
      <div className="bg-gray-50/60 p-5 border-t border-gray-100 space-y-2.5">
        <span className="text-[10px] uppercase font-bold tracking-wider text-gray-400 block">Coordonnées professionnelles</span>
        <div className="grid grid-cols-1 gap-2 text-xs text-gray-600">
          {enterprise.contact.phone && (
            <a href={`tel:${enterprise.contact.phone.replace(/\s+/g, '').split('/')[0]}`} className="flex items-center hover:text-emerald-700 transition-colors group/link">
              <Phone size={13} className="mr-2.5 text-gray-400 group-hover/link:text-emerald-600 flex-shrink-0" />
              <span className="font-medium truncate">{enterprise.contact.phone}</span>
            </a>
          )}
          {enterprise.contact.email && (
            <a href={`mailto:${enterprise.contact.email}`} className="flex items-center hover:text-emerald-700 transition-colors group/link">
              <Mail size={13} className="mr-2.5 text-gray-400 group-hover/link:text-emerald-600 flex-shrink-0" />
              <span className="truncate">{enterprise.contact.email}</span>
            </a>
          )}
          {enterprise.contact.website && (
            <a href={enterprise.contact.website} target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-emerald-700 transition-colors group/link pt-0.5">
              <Globe size={13} className="mr-2.5 text-gray-400 group-hover/link:text-emerald-600 flex-shrink-0" />
              <span className="truncate font-medium underline decoration-gray-200 group-hover/link:decoration-emerald-700 flex items-center gap-1">
                {enterprise.contact.website.replace('https://', '').replace('www.', '')}
                <ExternalLink size={10} className="opacity-60" />
              </span>
            </a>
          )}
        </div>
      </div>
    </motion.div>
  );
});

// Ajout du displayName pour le débogage
EnterpriseCard.displayName = 'EnterpriseCard';

const Enterprises = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTag, setSelectedTag] = useState('Tous');

  // Extraction unique des tags pour le système de filtrage
  const allTags = useMemo(() => {
    const tagsSet = new Set(['Tous']);
    enterprisesData.forEach(ent => ent.tags?.forEach(tag => tagsSet.add(tag)));
    return Array.from(tagsSet);
  }, []);

  // Logique de filtrage et recherche combinée
  const filteredEnterprises = useMemo(() => {
    return enterprisesData.filter(enterprise => {
      const matchesSearch = 
        enterprise.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        enterprise.founder.toLowerCase().includes(searchTerm.toLowerCase()) ||
        enterprise.activity.toLowerCase().includes(searchTerm.toLowerCase());
      
      const matchesTag = selectedTag === 'Tous' || enterprise.tags?.includes(selectedTag);
      
      return matchesSearch && matchesTag;
    });
  }, [searchTerm, selectedTag]);

  return (
    <div className="bg-gray-50/50 min-h-screen py-16 px-4 sm:px-6 lg:px-8 antialiased">
      <div className="max-w-7xl mx-auto">
        
        {/* Header Section */}
        <div className="flex flex-col items-center mb-16 text-center">
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-800 text-xs font-bold px-4 py-2 rounded-full mb-5 border border-emerald-100 shadow-sm"
          >
            <TrendingUp className="w-3.5 h-3.5 text-emerald-600" />
            Annuaire Économique & Technologique
          </motion.div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 tracking-tight max-w-3xl leading-tight">
            L'Écosystème Entrepreneurial <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 to-teal-700">AIFASA 17</span>
          </h1>
          <div className="h-1.5 w-16 bg-gradient-to-r from-emerald-500 to-teal-600 my-5 rounded-full" />
          <p className="text-base text-gray-600 max-w-2xl font-normal leading-relaxed">
            Découvrez le savoir-faire, les structures agro-industrielles et les innovations portées à l'échelle nationale et internationale par les ingénieurs de notre promotion.
          </p>
        </div>

        {/* Search and Filters Architecture */}
        <div className="mb-10 bg-white p-5 rounded-2xl border border-gray-100 shadow-sm space-y-4">
          <div className="flex flex-col md:flex-row md:items-center gap-4">
            {/* Input de recherche */}
            <div className="relative flex-1">
              <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Rechercher une entreprise, un fondateur, un pôle..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 transition-all placeholder:text-gray-400"
              />
            </div>
            
            {/* Indicateur de volume */}
            <div className="text-xs text-gray-400 font-medium px-1 flex-shrink-0">
              {filteredEnterprises.length} structure{filteredEnterprises.length > 1 ? 's' : ''} trouvée{filteredEnterprises.length > 1 ? 's' : ''}
            </div>
          </div>

          {/* Boutons de Filtre par Catégorie */}
          <div className="flex flex-wrap items-center gap-1.5 pt-2 border-t border-gray-50">
            <span className="text-xs font-bold text-gray-400 mr-2 uppercase tracking-wider flex items-center gap-1">
              <Filter size={12} /> Filtrer :
            </span>
            {allTags.map((tag) => (
              <button
                key={tag}
                onClick={() => setSelectedTag(tag)}
                className={`text-xs px-3 py-1.5 rounded-lg font-medium transition-all duration-200 ${
                  selectedTag === tag 
                    ? 'bg-emerald-600 text-white shadow-sm shadow-emerald-600/10' 
                    : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                }`}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        {/* Dynamic Cards Grid Matrix */}
        <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          <AnimatePresence mode="popLayout">
            {filteredEnterprises.map((enterprise, index) => (
              <EnterpriseCard key={enterprise.id} enterprise={enterprise} index={index} />
            ))}
          </AnimatePresence>
        </motion.div>

        {/* Empty State Fallback */}
        {filteredEnterprises.length === 0 && (
          <motion.div 
            initial={{ opacity: 0 }} 
            animate={{ opacity: 1 }} 
            className="text-center py-16 bg-white rounded-2xl border border-dashed border-gray-200 max-w-md mx-auto mt-6"
          >
            <div className="p-3 bg-gray-50 rounded-full inline-block mb-3 text-gray-400">
              <Building size={24} />
            </div>
            <h3 className="text-sm font-semibold text-gray-800">Aucun résultat trouvé</h3>
            <p className="text-xs text-gray-500 mt-1 px-4">Ajustez vos filtres ou modifiez les mots clés de votre recherche pour découvrir les entreprises membres.</p>
          </motion.div>
        )}

        {/* Section Projets Stratégiques 2026-2027 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-24 bg-gradient-to-br from-gray-900 to-slate-950 rounded-3xl shadow-xl p-6 sm:p-10 text-white relative overflow-hidden"
        >
          {/* Subtle Background Glow Accent */}
          <div className="absolute top-0 right-0 w-80 h-80 bg-emerald-500/10 blur-[100px] pointer-events-none rounded-full" />
          
          <div className="flex flex-col md:flex-row md:items-center gap-4 mb-8 relative z-10">
            <div className="p-3 bg-emerald-500/10 border border-emerald-500/20 rounded-2xl inline-block text-emerald-400">
              <Rocket className="w-6 h-6" />
            </div>
            <div>
              <h3 className="text-xl sm:text-2xl font-black tracking-tight">Grands Projets Stratégiques 2026-2027</h3>
            </div>
            <div className="md:ml-auto bg-emerald-500/10 border border-emerald-500/20 px-3 py-1 rounded-full self-start md:self-center">
              <span className="text-[11px] font-bold text-emerald-400">6 Programmes Clés</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 relative z-10">
            {comingSoonData.map((item, index) => {
              const IconComponent = item.icon;
              return (
                <div 
                  key={index}
                  className={`flex flex-col justify-between p-5 bg-white/[0.03] hover:bg-white/[0.06] border border-white/[0.05] hover:border-white/[0.1] rounded-2xl transition-all duration-300 group`}
                >
                  <div>
                    <div className="flex items-center gap-3 mb-3">
                      <div className={`p-2 rounded-xl bg-white/[0.04] ${item.iconColor} border border-white/[0.05]`}>
                        <IconComponent className="w-4 h-4" />
                      </div>
                      <h4 className="text-sm font-bold text-gray-100 group-hover:text-emerald-400 transition-colors line-clamp-1">
                        {item.name}
                      </h4>
                    </div>
                    <p className="text-xs text-gray-400 leading-relaxed min-h-[48px]">{item.activity}</p>
                  </div>
                  
                  <div className="mt-4 pt-3 border-t border-white/[0.04] flex flex-wrap items-center gap-2 text-[10px]">
                    <span className="bg-emerald-500/10 text-emerald-400 px-2 py-0.5 rounded-md font-semibold border border-emerald-500/20">
                      {item.axe}
                    </span>
                    <span className="bg-blue-500/10 text-blue-400 px-2 py-0.5 rounded-md font-medium border border-blue-500/20 flex items-center gap-0.5">
                      <DollarSign size={10} /> {item.budget}
                    </span>
                    <span className="bg-amber-500/10 text-amber-400 px-2 py-0.5 rounded-md font-medium border border-amber-500/20 flex items-center gap-1">
                      <Calendar size={10} /> {item.deadline}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-8 pt-6 border-t border-white/[0.05] text-center relative z-10">
            <p className="text-xs text-gray-400">
              Ces infrastructures et modules applicatifs constituent le socle de souveraineté numérique de la promotion.
              <button className="text-emerald-400 hover:text-emerald-300 font-bold ml-1 transition-colors inline-flex items-center gap-0.5 group">
                Consulter le schéma directeur <ChevronRight size={12} className="group-hover:translate-x-0.5 transition-transform" />
              </button>
            </p>
          </div>
        </motion.div>

        {/* Global Action Call */}
        <div className="mt-16 text-center">
          <a
            href="/membres"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-emerald-600 to-teal-700 hover:from-emerald-700 hover:to-teal-800 text-white font-bold text-sm px-6 py-3.5 rounded-xl transition-all shadow-md hover:shadow-lg shadow-emerald-700/10 hover:-translate-y-0.5"
          >
            <Users className="w-4 h-4" />
            Consulter l'Annuaire Global des Membres
          </a>
        </div>
      </div>
    </div>
  );
};

export default Enterprises;